import { render, staticRenderFns } from "./passport.vue?vue&type=template&id=6ef4f6cc&scoped=true&"
import script from "./passport.vue?vue&type=script&lang=js&"
export * from "./passport.vue?vue&type=script&lang=js&"
import style0 from "./passport.vue?vue&type=style&index=0&id=6ef4f6cc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef4f6cc",
  null
  
)

export default component.exports